import styled from 'styled-components';
import { Divider, Flex } from 'antd';
import { maxWidth } from 'config/constants';

export const StyledServiceRequestFormPage = styled(Flex)`
  width: 100%;
  height: 100%;
  background: white;
`;

export const StyledServiceRequestFormContent = styled(Flex)`
  width: 100%;
  max-width: 580px;
  margin: auto;

  ${maxWidth.l} {
    max-width: 100%;
    padding: 40px 36px;
    margin: 0 auto;
  }

  ${maxWidth.m} {
    padding: 48px 23px;
    margin: 0;
  }

  .send-code-button {
    span::first-letter {
      text-transform: uppercase;
    }
  }

  .ant-form-item-label {
    font-weight: ${({ theme }): number => theme.kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
  }

  .ant-form-item-explain-error {
    margin-left: 8px;
    margin-top: 4px;
  }

  .ant-input-status-success {
    border-color: ${(props): string => props.theme.kcc.colors.TEXT};
  }
`;

export const StyledDivider = styled(Divider)`
  margin: 0;
`;
